import { DdsProvider } from '@norges-domstoler/dds-components';
import { BrowserRouter } from 'react-router';
import { Notifications } from './Notifications';
import { AppRoutes } from './Routes';
import { Swr } from './Swr';
import { ProvideEnheter } from 'src/contexts/EnheterContext';
import { LoggedInStatusProvider } from 'src/contexts/LoggedInStatusContext';
import { ProvideValgPerioder } from 'src/contexts/ValgPerioderContext';

function App() {
  return (
    <DdsProvider language="nb">
      <Notifications />
      <Swr>
        <LoggedInStatusProvider>
          <ProvideEnheter>
            <ProvideValgPerioder>
              <BrowserRouter>
                <AppRoutes />
              </BrowserRouter>
            </ProvideValgPerioder>
          </ProvideEnheter>
        </LoggedInStatusProvider>
      </Swr>
    </DdsProvider>
  );
}

export default App;
